import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import { PopupContainer } from 'src/common-ui/popup-container/popup-container.component';
export const ModalComponent = ({ children, title }) => {
    return (React.createElement(PopupContainer, { className: "modal-container" },
        React.createElement("div", { className: "modal-title" }, getMessage(title)),
        React.createElement("div", { className: "modal-content" }, children)));
};
